import { render, staticRenderFns } from "./mvAuthorityOpen.vue?vue&type=template&id=5a99e994"
import script from "./mvAuthorityOpen.vue?vue&type=script&lang=js"
export * from "./mvAuthorityOpen.vue?vue&type=script&lang=js"
import style0 from "./mvAuthorityOpen.vue?vue&type=style&index=0&id=5a99e994&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports